import {updateDates} from '../../commons/actions/dates'
import {GET_ORDER, PLACE_ORDER, UPDATE_ORDER} from '../actions/placed-order'

export const datesMiddleware = (store) => (next) => (action) => {
  switch (action.type) {
    case PLACE_ORDER.SUCCESS:
    case UPDATE_ORDER.SUCCESS:
    case GET_ORDER.SUCCESS: {
      store.dispatch(updateDates(action.payload.dates))
      break
    }
    default:
      break
  }
  next(action)
}
